if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const fields = window.SubscriptionFields;
        const dataloggerProblem = fields ? fields.validateProductForm(this.form) : null;
        if (dataloggerProblem) {
          this.handleErrorMessage(dataloggerProblem.message);
          return;
        }

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.setChecking(true);

        const cartCheck = fields ? fields.checkCart(this.form) : Promise.resolve(null);
        cartCheck
          .then((problem) => problem || (fields ? fields.checkDevice(this.form) : null))
          .then((problem) => {
            if (problem) {
              this.setChecking(false);
              this.submitButton.removeAttribute('aria-disabled');
              this.handleErrorMessage(problem.message);
              return;
            }
            this.addToCart(fields);
          });
      }

      setChecking(active) {
        this.submitButton.classList.toggle('loading', active);
        this.querySelector('.loading__spinner').classList.toggle('hidden', !active);
      }

      addToCart(fields) {
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = fields
          ? fields.withoutEmptyInputs(this.form, () => new FormData(this.form))
          : new FormData(this.form);
        const feeRef = this.companionVariantId ? this.newFeeRef() : null;
        if (feeRef) formData.append('properties[_fee_ref]', feeRef);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => (response.status ? response : this.addCompanionItem(response, feeRef)))
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      get companionVariantId() {
        return Number(this.form.dataset.companionVariantId) || 0;
      }

      newFeeRef() {
        return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
      }

      addCompanionItem(response, feeRef) {
        const companionId = this.companionVariantId;
        if (!companionId || !this.cart) return response;

        const config = fetchConfig('javascript');
        config.body = JSON.stringify({
          items: [{ id: companionId, quantity: 1, properties: { _fee_ref: feeRef } }],
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });
        return fetch(`${routes.cart_add_url}`, config)
          .then((companionResponse) => companionResponse.json())
          .then((companion) => (companion.status ? response : companion))
          .catch(() => response);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
